import React from 'react'
import Header from '../_components/common/Header'
import Index from '../_components/Help/Index'

const Help = () => {
  return (
    <div className='page-main'>
        <Header name = {["Help"]}/>
        <Index />
       
    </div>
  )
}

export default Help